import moment from "moment-timezone";

import ACCOUNTING_CLOSING_FROM_COMPANY from "../graphql/accountingClosing/AccountingClosingFromCompany.gql";
import { AccountingClosing } from "../../../types";

export function getCurrentAccountingPeriod(accountingPeriods, aaId = undefined) {
    if (!accountingPeriods || !accountingPeriods.length) return undefined;

    if (aaId) {
        const accountingPeriod = accountingPeriods.find((aa) => aa.id === aaId);
        if (accountingPeriod) {
            return accountingPeriod;
        }
    }
    const date = moment();

    for (const ap of accountingPeriods) {
        const start = moment(ap.start);
        const end = moment(ap.end);
        if (date.isSameOrAfter(start) && date.isSameOrBefore(end)) {
            return ap;
        }
    }
    return accountingPeriods[accountingPeriods.length - 1];
}

export function getCurrentAccountingPeriodFromDate(accountingPeriods, date) {
    // ** date comes in .format("YYYY-MM-DD")
    if (!accountingPeriods?.length || !date) {
        return undefined;
    }

    for (const ap of accountingPeriods) {
        const start = moment(ap.start).format("YYYY-MM-DD");
        const end = moment(ap.end).format("YYYY-MM-DD");
        if (date >= start && date <= end) {
            return ap;
        }
    }

    return undefined;
}

export function getN_1AccountingPeriod(storeAccountingPeriod, apId) {
    // ** pay attention: getN_1AccountingPeriod needs :
    // ** in back  periodS + currentPeriod(no id), because control receives this.company.accountingPeriods + this.period (containing closed information)
    // ** in front store.period(who contains currentPeriod + periodS) + currentPeriodId, because control receives only this.accountingPeriodId, and we have to seek in store for periods and full currentPeriod

    if (
        !storeAccountingPeriod.accountingPeriods?.length ||
        storeAccountingPeriod.accountingPeriods.length <= 1
    ) {
        return undefined;
    }
    const clonedAccountingPeriod = storeAccountingPeriod; //cloneDeep(storeAccountingPeriod as any)
    // const clonedStore = cloneDeep(store as object)

    let selectedAP: any = {};

    if (apId) {
        selectedAP = clonedAccountingPeriod.accountingPeriods.find((ap) => ap.id === apId);
    } else if (clonedAccountingPeriod.selectedAccountingPeriod?.start) {
        selectedAP = clonedAccountingPeriod.selectedAccountingPeriod;
    }

    if (selectedAP?.id) {
        const selectedAPStartYYYYMMDD = moment(selectedAP.start).format("YYYY-MM-DD");

        const previousEnd = moment(selectedAPStartYYYYMMDD).add(-1, "days").format("YYYY-MM-DD");

        for (const ap of clonedAccountingPeriod.accountingPeriods) {
            const apEnd = moment(ap.end).format("YYYY-MM-DD");
            if (apEnd === previousEnd) {
                return ap;
            }
        }
    }
    return undefined;
}

// ** AUDIT REPORT - return true if closed or not existing period
export function isInsideClosedAccountingPeriodAuditReport(accountingPeriods, date) {
    const mDate = moment(date);
    if (!mDate.isValid()) {
        return false;
    }

    if (accountingPeriods.length) {
        const clonedAccountingPeriods = [...accountingPeriods];

        // ** sorted from more recent to oldest
        clonedAccountingPeriods.sort((a, b) => {
            if (a.end < b.end) return 1;
            if (a.end > b.end) return -1;
            return 0;
        });

        if (mDate.isAfter(moment(clonedAccountingPeriods[0].end))) {
            return false;
        }

        for (const ap of clonedAccountingPeriods) {
            if (ap.closed && moment(ap.start).isAfter(mDate)) {
                return true;
            }
            if (moment(ap.start).isSameOrBefore(mDate) && mDate.isSameOrBefore(moment(ap.end))) {
                if (ap.closed) {
                    return true;
                }
                return false;
            }
        }
    }

    return true;
}

export function isInsideClosedAccountingPeriod(store, date) {
    if (!date) {
        return false;
    }
    if (
        !store ||
        !store.state ||
        !store.state.accountingPeriod ||
        !store.state.accountingPeriod.accountingPeriods
    ) {
        return false;
    }
    const accountingPeriods = store.state.accountingPeriod.accountingPeriods;
    return !filterWithoutClosedAccountingPeriods(accountingPeriods, date);
}

export function isInsideAccountingClosing(store, date) {
    if (!date) {
        return false;
    }

    const lastAccountingClosingDate = getLastAccountingClosingFromStore(store);
    if (!lastAccountingClosingDate) {
        return false;
    } else {
        const lastClosingEndDate = lastAccountingClosingDate.lastAccountingClosing.endDate;
        if (moment(date).format("YYYYMMDD") <= moment(lastClosingEndDate).format("YYYYMMDD")) {
            return true;
        }
    }

    return false;
}

export function filterWithoutClosedAccountingPeriods(accountingPeriods, date) {
    const mDate = moment(date);
    if (!mDate.isValid()) {
        return true;
    }
    if (!accountingPeriods.length) {
        return true;
    }
    for (const ap of accountingPeriods) {
        if (
            ap.closed &&
            moment(ap.start).isSameOrBefore(mDate) &&
            mDate.isSameOrBefore(moment(ap.end))
        ) {
            return false;
        }
    }
    return true;
}

export function dateInsideAccountingPeriods(storeAccountingPeriods, date, accountingPeriodId = "") {
    const mDate = moment(date, "YYYY-MM-DD", true); // Format strict
    if (!mDate.isValid()) {
        console.error("Invalid mDate:", date);
        return true;
    }

    if (!storeAccountingPeriods.length) {
        return false;
    }

    let accountingPeriods = storeAccountingPeriods;

    if (accountingPeriodId?.length) {
        accountingPeriods = accountingPeriods.filter((ap) => ap.id !== accountingPeriodId);
    }

    for (const ap of accountingPeriods) {
        // debugger;
        const apStart = moment(ap.start).format("YYYY-MM-DD");
        const apEnd = moment(ap.end).format("YYYY-MM-DD");

        const mDateYYYYMMDD = mDate.format("YYYY-MM-DD");
        if (apStart <= mDateYYYYMMDD && mDateYYYYMMDD <= apEnd) {
            return true;
        }
    }
    return false;
}

export function filterWithSelectedAccountingPeriod(selectedAccountingPeriod, date) {
    if (selectedAccountingPeriod) {
        const mDate = moment(date);
        if (
            moment(selectedAccountingPeriod.start).isSameOrBefore(mDate) &&
            mDate.isSameOrBefore(moment(selectedAccountingPeriod.end))
        ) {
            return true;
        }
        return false;
    }
    return true;
}

export function getFirstPeriod(
    accountingPeriod,
    startBusinessDate,
    firstAccountingPeriodEnd,
    accountingPeriods,
) {
    let firstPeriod: any = {
        start: "",
        end: "",
    };

    const mAccountingPeriodStart = moment(accountingPeriod.start).format("YYYY-MM-DD");
    const mAccountingPeriodEnd = moment(accountingPeriod.end).format("YYYY-MM-DD");
    const mStartBusinessDate = moment(startBusinessDate).format("YYYY-MM-DD");
    const mFirstAccountingPeriodEnd = moment(firstAccountingPeriodEnd).format("YYYY-MM-DD");

    // ** firstPeriod === accountingPeriod
    if (
        mAccountingPeriodStart === mStartBusinessDate &&
        mAccountingPeriodEnd === mFirstAccountingPeriodEnd
    ) {
        firstPeriod = accountingPeriod;
        return firstPeriod;
    } else {
        const mStartBusinessDateMinus2 = moment(mStartBusinessDate)
            .add(-2, "days")
            .format("YYYY-MM-DD");
        const mStartBusinessDatePlus2 = moment(mStartBusinessDate)
            .add(2, "days")
            .format("YYYY-MM-DD");

        // const mFirstAccountingPeriodEndMinus2 = moment(mFirstAccountingPeriodEnd).add(-2).format('YYYY-MM-DD')
        // const mFirstAccountingPeriodEndPlus2 = moment(mFirstAccountingPeriodEnd).add(2).format('YYYY-MM-DD')

        if (accountingPeriods.length) {
            // ** firstPeriod == accountingPeriod +-2 days
            const founded = accountingPeriods.find(
                (ap) =>
                    moment(ap.start).isSame(mStartBusinessDate) ||
                    // moment(ap).format('YYYY-MM-DD') === mFirstAccountingPeriodEnd ||
                    (moment(ap.start).isSameOrAfter(mStartBusinessDateMinus2) &&
                        moment(ap.start).isSameOrBefore(mStartBusinessDatePlus2)),
            );

            if (founded) {
                return founded;
            } else {
                // ** not existing accountingPeriod
                // ** start
                // const fullYearAccountingPeriodStartDD = + moment(mAccountingPeriodStart).format('DD')
                // const startBusinessDateDD = + moment(startBusinessDate).format("DD")

                // const fullYearAccountingPeriodStartMM = + moment(mAccountingPeriodEnd).format('MM')
                // const startBusinessDateMM = + moment(startBusinessDate).format("MM")

                // ** end
                const fullYearAccountingPeriodEndDD = +moment(mAccountingPeriodEnd).format("DD");
                const firstAccountingPeriodEndDD = +moment(firstAccountingPeriodEnd).format("DD");

                const fullYearAccountingPeriodEndMM = +moment(mAccountingPeriodEnd).format("MM");
                const mFirstAccountingPeriodEndMM = +moment(firstAccountingPeriodEnd).format("MM");

                const fullYearAccountingPeriodEndYYYY =
                    +moment(mAccountingPeriodEnd).format("YYYY");
                const mFirstAccountingPeriodEndYYYY =
                    +moment(firstAccountingPeriodEnd).format("YYYY");

                if (
                    fullYearAccountingPeriodEndDD === firstAccountingPeriodEndDD &&
                    mFirstAccountingPeriodEndMM === fullYearAccountingPeriodEndMM &&
                    fullYearAccountingPeriodEndYYYY === mFirstAccountingPeriodEndYYYY
                ) {
                    firstPeriod.start = moment(startBusinessDate).format("YYYY-MM-DD");
                    firstPeriod.end = moment(firstAccountingPeriodEnd).format("YYYY-MM-DD");
                    firstPeriod.closed = true;
                    return firstPeriod;
                } else {
                    const firstPeriodEnd = moment(firstPeriod.start)
                        .month(fullYearAccountingPeriodEndMM - 1) // ** month first else
                        .date(fullYearAccountingPeriodEndDD) // ** if firstPeriod.start DD 30 and new value 31 = 01-next month
                        .format("YYYY-MM-DD");

                    const differ = moment(mFirstAccountingPeriodEnd).diff(firstPeriodEnd, "days");

                    if (
                        !differ ||
                        (differ <= 2 && differ >= -2) ||
                        (differ <= 368 && differ >= -368)
                    ) {
                        firstPeriod.end = firstPeriodEnd;
                    } else {
                        firstPeriod.end = moment(firstPeriodEnd)
                            .add(1, "days")
                            .endOf("year")
                            .format("YYYY-MM-DD");
                    }
                    firstPeriod.closed = true;

                    return firstPeriod;
                }
            }
        }
    }

    return firstPeriod;
}

export function getLastClosedAndFirstOpenAccountingPeriods(storeAccountingPeriods) {
    // **  used in checkFixedAssetCutPrevious + toDepreciate
    if (storeAccountingPeriods?.length) {
        //
        // Attention storeAccountingPeriods vient du store : il ne faut pas le modifier => je l'ai cloné
        //
        const accountingPeriods = storeAccountingPeriods; // cloneDeep(storeAccountingPeriods)

        const closedPeriods = [];
        const unclosedPeriods = [];
        let lastClosedPeriod: any = {};
        let firstUnclosedPeriod: any = {};

        // ** sorted from more recent to oldest
        accountingPeriods.sort((a, b) => {
            if (a.end < b.end) return 1;
            if (a.end > b.end) return -1;
            return 0;
        });

        // ** sorted from more recent to oldest
        for (const ap of accountingPeriods) {
            if (!ap.closed) {
                if (closedPeriods.length) {
                    // ** sorted DESC: more recent to oldest
                    // ** if some closedPeriods, followings are closed too
                    closedPeriods.push(ap);
                } else {
                    unclosedPeriods.push(ap);
                }
            } else {
                closedPeriods.push(ap);
            }
        }

        if (closedPeriods.length) {
            lastClosedPeriod = closedPeriods[0];
        }

        if (unclosedPeriods?.length) {
            firstUnclosedPeriod = unclosedPeriods[unclosedPeriods.length - 1];
        } else {
            console.error("error in getLastClosedAndFirstOpenAccountingPeriod: no unclosedPeriods");
        }
        return {
            lastClosedPeriod: lastClosedPeriod.id ? lastClosedPeriod : undefined,
            firstUnclosedPeriod: firstUnclosedPeriod.id ? firstUnclosedPeriod : undefined,
        };
    } else {
        console.error("error in getLastClosedAndFirstOpenAccountingPeriod: no accountingPeriods");
        return {
            lastClosedPeriod: undefined,
            firstUnclosedPeriod: undefined,
        };
    }
}

export function getLastAccountingPeriod(storeAccountingPeriods) {
    if (storeAccountingPeriods?.length) {
        //
        // Attention storeAccountingPeriods vient du store : il ne faut pas le modifier => je l'ai cloné
        //
        const accountingPeriods = storeAccountingPeriods; //cloneDeep(storeAccountingPeriods)

        // ** sorted from more recent to oldest
        accountingPeriods.sort((a, b) => {
            if (a.end < b.end) return 1;
            if (a.end > b.end) return -1;
            return 0;
        });

        // ** sorted from more recent to oldest
        return accountingPeriods[0];
    }
    return undefined;
}

export function getAccountingDate(store, date) {
    // ** if closed period : first available date to generate an accounting document
    let mDate = moment(date);
    if (!mDate.isValid()) {
        mDate = moment();
    }
    if (
        !store ||
        !store.state ||
        !store.state.accountingPeriod ||
        !store.state.accountingPeriod.accountingPeriods
    ) {
        return mDate.format();
    }
    const accountingPeriods = store.state.accountingPeriod.accountingPeriods;
    if (!accountingPeriods.length) {
        return mDate.format();
    }

    let firstIndice = 0;
    for (const ap of accountingPeriods) {
        firstIndice++;
        if (moment(ap.start).isSameOrBefore(mDate) && mDate.isSameOrBefore(moment(ap.end))) {
            if (!ap.closed) {
                return mDate.format();
            }
            for (let index = firstIndice; index < accountingPeriods.length; index++) {
                const nextAP = accountingPeriods[index];
                if (!nextAP.closed) {
                    return moment(nextAP.start).format();
                }
            }
        }
    }
    const lastAP = accountingPeriods[accountingPeriods.length - 1];
    return moment(lastAP.end).add(1, "days").format();
}

export function monthsInFrench(momentVariable, addNumberOfTheDay = false) {
    const dicoMonthsFR = {
        1: "Jan",
        2: "Fev",
        3: "Mar",
        4: "Avr",
        5: "Mai",
        6: "Jun",
        7: "Jul",
        8: "Aou",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec",
    };
    let result = addNumberOfTheDay ? momentVariable.format("DD") + " " : "";
    result += dicoMonthsFR[momentVariable.format("M")].concat(" ", momentVariable.format("YYYY"));
    return result;
}

export function getAccountingPeriodStartMonths(
    accountingPeriod,
    accountingAvailabilityDate: string = undefined,
) {
    const result = [];

    if (accountingPeriod && accountingPeriod.start && accountingPeriod.end) {
        const mStart = moment(accountingPeriod.start);
        let mEnd = moment(accountingPeriod.end).endOf("month");
        if (accountingAvailabilityDate) {
            if (moment(accountingAvailabilityDate).isBefore(mStart)) {
                return result;
            }
            if (moment(accountingAvailabilityDate).isBefore(mEnd)) {
                mEnd = moment(accountingAvailabilityDate).endOf("month");
            }
        }

        const momentVariable = mStart;
        while (momentVariable < mEnd) {
            result.push({
                title: monthsInFrench(momentVariable, true),
                value: momentVariable.format("YYYY-MM-DD"),
                disabled: false,
            });
            momentVariable.add(1, "month").startOf("month");
        }
    }
    return result;
}

export function getAccountingPeriodEndMonths(
    accountingPeriod,
    accountingAvailabilityDate: string = undefined,
) {
    const result = [];

    if (accountingPeriod && accountingPeriod.start && accountingPeriod.end) {
        const mStart = moment(accountingPeriod.start);
        let mEnd = moment(accountingPeriod.end);
        if (accountingAvailabilityDate) {
            if (moment(accountingAvailabilityDate).isBefore(mStart)) {
                return result;
            }
            if (moment(accountingAvailabilityDate).isBefore(mEnd)) {
                mEnd = moment(accountingAvailabilityDate);
            }
        }

        let momentVariable = mStart;
        while (momentVariable <= mEnd) {
            momentVariable = momentVariable.endOf("month");
            result.push({
                title: monthsInFrench(momentVariable.endOf("month"), true),
                value: momentVariable.endOf("month").format("YYYY-MM-DD"),
                disabled: false,
            });
            momentVariable.add(1, "day");
        }
    }
    return result;
}

export function getAccountingPublishDates(store) {
    const result = [{ title: "Pas de publication", value: "" }];
    if (!store?.state?.accountingPeriod?.accountingPeriods?.length) {
        return result;
    }
    const accountingPeriods = store.state.accountingPeriod.accountingPeriods;

    for (let index = accountingPeriods.length - 1; index >= 0; index--) {
        const ap = accountingPeriods[index];
        const dates = getAccountingPeriodEndMonths(ap, undefined);
        for (let id = dates.length - 1; id >= 0; id--) {
            result.push(dates[id]);
        }
    }

    return result;
}

export async function getLastAccountingClosing(apollo, companyId): Promise<AccountingClosing> {
    const res2 = await apollo.query({
        query: ACCOUNTING_CLOSING_FROM_COMPANY,
        variables: {
            companyId: companyId,
        },
    });

    if (res2?.data?.accountingClosings?.length) {
        return res2.data.accountingClosings[0];
    }

    return undefined;
}

export function getLastAccountingClosingFromStore(store) {
    if (!store?.state?.accountingPeriod?.accountingPeriods?.length) {
        return "";
    }
    const accountingPeriods = store.state.accountingPeriod.accountingPeriods;

    for (let index = accountingPeriods.length - 1; index >= 0; index--) {
        const ap = accountingPeriods[index];
        // if (ap.closed) {
        //     return ap
        // }
        if (ap.accountingClosings?.length) {
            // return ap.accountingClosings[ap.accountingClosings.length-1]
            return {
                lastAccountingPeriodWithAccountingClosing: ap,
                lastAccountingClosing: ap.accountingClosings[ap.accountingClosings.length - 1],
            };
        }
    }
    return undefined;
}

export function getLastAccountingClosingEndDateFromStore(store) {
    if (!store?.state?.accountingPeriod?.accountingPeriods?.length) {
        return "";
    }
    const accountingPeriods = store.state.accountingPeriod.accountingPeriods;

    for (let index = accountingPeriods.length - 1; index >= 0; index--) {
        const ap = accountingPeriods[index];
        // if (ap.closed) {
        //     return ap.end
        // }
        if (ap.accountingClosings?.length) {
            return ap.accountingClosings[ap.accountingClosings.length - 1].endDate;
        }
    }
    return "";
}

export function getAccountingPeriodOfDate_fromStore(store, date) {
    if (!store?.state?.accountingPeriod?.accountingPeriods?.length) {
        return "";
    }
    const accountingPeriods = store.state.accountingPeriod.accountingPeriods;

    const mDate = moment(date).format("YYYY-MM-DD");

    // ** format ap.start / end with different hour tested on moment sandbox :
    // ** moment("2019-01-01T01:00:00.000Z").isSame("2019-01-01") => true
    const dateAccountingPeriod = accountingPeriods.find(
        (ap) => moment(ap.start).isSameOrBefore(mDate) && moment(ap.end).isSameOrAfter(mDate),
    );
    // if (ap.closed) {
    //     return ap.end
    // }
    if (dateAccountingPeriod) {
        return dateAccountingPeriod;
    }

    return "";
}

export async function getAccountingClosingDate(apollo, companyId, date) {
    const lastAccountingClosing = await getLastAccountingClosing(apollo, companyId);
    if (lastAccountingClosing) {
        return getAccountingDateWithAccountingClosing(lastAccountingClosing, date);
    }
    return date;
}

function getAccountingDateWithAccountingClosing(lastAccountingClosing, date) {
    if (!lastAccountingClosing) {
        return date;
    }

    const mDate = moment(date);
    if (!mDate.isValid()) {
        return date;
    }
    if (moment(lastAccountingClosing.endDate).isSameOrAfter(date)) {
        return moment(lastAccountingClosing.endDate).add(1, "days").startOf("day").format();
    }
    return date;
}

export function getAccountingPeriodsSuiteError(accountingPeriods) {
    if (!accountingPeriods?.length) {
        return [];
    }
    accountingPeriods.sort((a, b) => {
        if (a.start < b.start) return 1;
        if (a.start > b.start) return -1;
        return 0;
    });
    const wrongAccountingPeriodSuite = [];
    for (let index = 0; index < accountingPeriods.length - 1; index++) {
        const nAP = accountingPeriods[index];
        if (accountingPeriods[index + 1]?.end) {
            const n_1AP = accountingPeriods[index + 1];
            const n_1APEnd = moment(n_1AP.end).format("YYYY-MM-DD");
            const theoreticalEnd = moment(nAP.start).add(-1, "days").format("YYYY-MM-DD");
            if (theoreticalEnd < n_1APEnd) {
                wrongAccountingPeriodSuite.push({
                    end: n_1APEnd,
                    id: n_1AP.id,
                });
            }
        }
    }
    if (wrongAccountingPeriodSuite.length) {
        return wrongAccountingPeriodSuite;
    }
    return undefined;
}

export function getMissingAccountingPeriodLaps(accountingPeriods) {
    if (!accountingPeriods?.length) {
        return [];
    }
    accountingPeriods.sort((a, b) => {
        if (a.start < b.start) return 1;
        if (a.start > b.start) return -1;
        return 0;
    });
    const missingAccountingPeriods = [];
    for (let index = 0; index < accountingPeriods.length - 1; index++) {
        const nAP = accountingPeriods[index];
        if (accountingPeriods[index + 1]?.end) {
            const n_1AP = accountingPeriods[index + 1];
            const theoreticalN_1End = moment(nAP.start).add(-1, "days").format("YYYY-MM-DD");
            const realN_1End = moment(n_1AP.end).format("YYYY-MM-DD");
            if (theoreticalN_1End > realN_1End) {
                const start = moment(n_1AP.end).add(1, "days").format("YYYY-MM-DD");

                missingAccountingPeriods.push({
                    end: theoreticalN_1End,
                    start: start,
                });
            }
        }
    }
    if (missingAccountingPeriods.length) {
        return missingAccountingPeriods;
    }
    return undefined;
}

/**
 * Get the most recent accounting period based on the start date
 * @param accountingPeriods - The accounting periods to search in
 * @returns The most recent accounting period or null if none are found
 */
export function getMostRecentAccountingPeriod(accountingPeriods) {
    if (!accountingPeriods?.length) {
        return null;
    }

    return accountingPeriods.reduce((mostRecent, current) =>
        moment(current.start).isBefore(moment(mostRecent.start)) ? mostRecent : current,
    );
}
